import React from 'react';
import PropsTypes from 'prop-types';
import styled from 'styled-components';
import ScrollLock, { TouchScrollable } from 'react-scrolllock';

import media from '../../main-app/utils/mediaQueries';

const Container = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: ${(props) => props.overlayColor};
  padding: 0 16px;
  //to overcome z-index: 10000 of the header
  z-index: 20000;
`;

const Content = styled.div`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: ${(props) => props.contentWidth}px;
  max-width: calc(100% - 32px);
  background-color: #fff;
  box-shadow: 0 -1px 1px 0 rgba(0, 0, 0, 0.02), 0 2px 4px 0 rgba(155, 132, 135, 0.06), 0 4px 12px 0 rgba(119, 94, 98, 0.05);
  border-radius: 12px;
  padding: 32px 40px 24px;
  max-height: 100%;
  overflow: ${(props) => props.overflow ? props.overflow : 'auto'};
  -webkit-overflow-scrolling: touch;

  ${media.mobile`
    ${(props) => props.isMobilesFullWidth && `
      position: fixed;
      width: auto;
      max-width: 100vw;
      top: auto;
      bottom: 0;
      left: 0;
      transform: none;
      border-bottom-left-radius: 0;
      border-bottom-right-radius: 0;
      padding: 20px 24px 24px;
    `}
  `}
`;

const Popup = ({
  children, width, overlayColor, overflow, isMobilesFullWidth,
}) => (
  <>
    <ScrollLock />
    <TouchScrollable>
      <Container overlayColor={overlayColor}>
        <Content contentWidth={width} overflow={overflow} isMobilesFullWidth={isMobilesFullWidth}>{children}</Content>
      </Container>
    </TouchScrollable>
  </>
);

Popup.propTypes = {
  children: PropsTypes.node.isRequired,
  width: PropsTypes.number,
  overlayColor: PropsTypes.string,
  overflow: PropsTypes.string,
  isMobilesFullWidth: PropsTypes.bool,
};

Popup.defaultProps = {
  width: 368,
  overlayColor: 'rgba(0,0,0,0.4)',
  overflow: 'auto',
  isMobilesFullWidth: false,
};

export { Popup };
